export function isNotHeader(t) {
    return !t.isHeader
}
